import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable, from, switchMap, catchError } from 'rxjs'
import { environment } from '../../../environments/environment'
import { throwIfCustomError } from '../../util/throwIfCustomError'

export interface ActiveSessionCountResponse {
  activeSessionCount: number
  timestamp: string
}

/** Firebaseトークンを取得するプロバイダー（テスト時に差し替え可能） */
export abstract class FirebaseTokenProvider {
  abstract getIdToken(): Promise<string>
}

/** Firebase Auth から実際のトークンを取得する */
@Injectable()
export class DefaultFirebaseTokenProvider extends FirebaseTokenProvider {
  async getIdToken(): Promise<string> {
    const { getAuth } = await import('firebase/auth')
    const auth = getAuth()
    const user = auth.currentUser

    if (!user) {
      throw new Error('Firebase user not found')
    }

    return user.getIdToken()
  }
}

/** roleplay-ws のアクティブセッション数を取得するサービス */
@Injectable({ providedIn: 'root' })
export class ActiveSessionCountService {
  private readonly baseUrl = environment.roleplayWsUrl.replace(/\/$/, '')

  constructor(
    private readonly http: HttpClient,
    private readonly tokenProvider: FirebaseTokenProvider,
  ) {}

  /** アクティブセッション数を取得する */
  getActiveSessionCount(): Observable<ActiveSessionCountResponse> {
    return from(this.tokenProvider.getIdToken()).pipe(
      switchMap((token: string) => {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`,
        })
        return this.http.get<ActiveSessionCountResponse>(
          `${this.baseUrl}/roleplay/ws/active-sessions`,
          { headers },
        )
      }),
      catchError((error: unknown) => {
        throwIfCustomError(error)
        throw error
      }),
    )
  }
}
